import { default as WscIconAVGen } from "./AVGen";
import { default as WscIconAVGenFilled } from "./AVGenFilled";
import { default as WscIconClipro } from "./Clipro";
import { default as WscIconCliproFilled } from "./CliproFilled";
import { default as WscIconCMS } from "./CMS";
import { default as WscIconCMSFilled } from "./CMSFilled";
import { default as WscIconGraphics } from "./Graphics";
import { default as WscIconGraphicsFilled } from "./GraphicsFilled";
import { default as WscIconLibrary } from "./Library";
import { default as WscIconLibraryFilled } from "./LibraryFilled";
import { default as WscIconPublishHub } from "./PublishHub";
import { default as WscIconPublishHubFilled } from "./PublishHubFilled";
import { default as WscIconCreate } from "./Create";
import { default as WscIconCreateFilled } from "./CreateFilled";
import { default as WscIconWscLogo } from "./WscLogo";
import { default as WscSingleSystemIndication } from "./SingleSystemIndication";
import { default as WscMultiSystemIndication } from "./MultiSystemIndication";
import { default as WscIconRules } from "./Rules";
import { default as WscIconRulesFilled } from "./RulesFilled";

const icons = {
  WscIconAVGen,
  WscIconAVGenFilled,
  WscIconClipro,
  WscIconCliproFilled,
  WscIconCMS,
  WscIconCMSFilled,
  WscIconGraphics,
  WscIconGraphicsFilled,
  WscIconLibrary,
  WscIconLibraryFilled,
  WscIconPublishHub,
  WscIconPublishHubFilled,
  WscIconCreate,
  WscIconCreateFilled,
  WscIconWscLogo,
  WscSingleSystemIndication,
  WscMultiSystemIndication,
  WscIconRules,
  WscIconRulesFilled,
};

export default icons;
